// extracted by mini-css-extract-plugin
export default {"container":"Styles_container__z-fRE","tagsContainer":"Styles_tagsContainer__hZD97","clearIcon":"Styles_clearIcon__foEx6","popover":"Styles_popover__gqczf"};